import React from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Typography
} from '@mui/material';

import AlertsList from '../AlertsList';

const AllAlerts = (props) => (
  <Card>
    <CardHeader
      subheader="List of all alerts"
      title="All Alerts"
    />
    <Divider />
    <CardContent>
      <Grid
        container
        spacing={6}
        wrap="wrap"
      >
        <Grid
          item
          md={4}
          sm={6}
          sx={{
            display: 'flex',
            flexDirection: 'column'
          }}
          xs={12}
        >
          <Typography
            color="textPrimary"
            gutterBottom
            variant="h6"
          >
            Notifications
          </Typography>
          <AlertsList />
        </Grid>
      </Grid>
    </CardContent>
    <Divider />
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        p: 2
      }}
    >
      <Button
        color="primary"
        variant="contained"
      >
        Save
      </Button>
    </Box>
  </Card>
);

export default AllAlerts;
